/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const ClubPageStyle = ({ palette, breakpoints, typography }) => ({
    main: {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
    },
    header: {
        width: '50%',
        margin: '0 5px',
        backgroundColor: palette.cms?.cardPagebackground || palette.cardPagebackground,
    },
    headerContent: {
        display: 'block',
        margin: '5px 0px 0px 25px',
    },
    headerLogo: {
        width: '306px',
        height: '81px',
        margin: '15px 0px 0px 132px',
        [breakpoints.down('md')]: {
            margin: '15px 0px 0px 25px',
        },
    },
    headerHeading: {
        fontSize: '16px',
        fontWeight: '600',
        fontFamily: 'arial regular',
        margin: '10px 18px',
        lineHeight: '1.5',
    },
    headerText: {
        fontSize: '16px',
        fontFamily: 'lato regular',
        lineHeight: '1.5',
        lineSpacing: '0.02em',
        margin: '10px 18px',
        width: '80%',
    },
    textHeadingCenter: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
    },
    headerFullContent: {
        maxWidth: '450px',
        textAlign: 'center',
    },
    clubTypes: {
        textAlign: 'center',
        margin: '7px 0px -10px 2px',
        cursor: 'pointer',
    },
    clubs: {
        fontSize: '20px',
        fontFamily: 'lato regular',
        margin: '3px',
        display: 'inline-block',
        padding: '0 4px',
        outline: 'none',
        '&:hover': {
            backgroundColor: palette.cms?.cardPagebackground || palette.cardPagebackground,
        },
        '&:focus': {
            backgroundColor: palette.cms?.cardPagebackground || palette.cardPagebackground,
        },
    },
    clubsType: {
        backgroundColor: palette.cms?.clubsTypebackground || palette.clubsTypebackground,
    },
    clubHeading: {
        fontSize: '20px',
        color: palette.contentColor,
        fontWeight: '400',
        fontFamily: 'lato bold',
        textAlign: 'center',
        paddingTop: '40px',
        lineHeight: '1.5',
    },
    typeContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        padding: '0px 0px 40px 0px',
        margin: '0 auto',
        maxWidth: '1440px',
        width: '100%',
    },
    typeData: {
        flexBasis: 'auto',
        padding: '20px',
        margin: '10px 0',
        border: `solid 1px ${palette.crBgColor}`,
        background: palette.white,
        overflow: 'visible',
        width: '49%',
        height: '320px',
        boxSizing: 'border-box',
        [breakpoints.down('md')]: {
            height: 'auto',
            minHeight: '320px',
        },
    },
    typeImage: {
        borderRadius: '50%',
        objectPosition: 'center',
        width: '280px',
        height: '280px',
    },
    disclaimer: {
        backgroundColor: palette.cms?.clubsTypebackground || palette.clubsTypebackground,
        padding: '0px 20px 0px 20px',
        contain: 'content',
    },
    priceText: {
        fontSize: '16px',
        fontWeight: '600',
        '& span': {
            padding: '5px 5px 5px 0',
        },
    },

    disclaimerHeading: {
        fontSize: '16px',
        fontFamily: 'arial',
        fontWeight: '600',
        maxWidth: '1400px',
        margin: '0 auto',
    },
    disclaimerContent: {
        fontSize: '14px',
        fontFamily: 'arial',
        maxWidth: '1400px',
        margin: '15px auto',
    },
    content: {
        padding: '0px 0px 0px 44px',
        width: '50%',
        float: 'left',
        [breakpoints?.down('md')]: {
            padding: '0px 0px 0px 20px',
        },
        '&>span': {
            fontSize: '1.1em',
        },
        '& p': {
            margin: '10px 0px !important',
        },
    },
    buyNowButton: {
        color: palette.white,
        backgroundColor: palette.cms?.buttonBackgroundColor || palette.buttonBackgroundColor,
        fontFamily: typography.fontFamily,
        boxSizing: 'border-box',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontWeight: '700',
        width: '195px',
        height: '40px',
        fontSize: '1.3em',
        textTransform: 'uppercase',
        lineHeight: '1.46em',
        padding: '5px 24px 5px 24px',
        [breakpoints.down('md')]: {
            fontSize: '1em',
            width: '100%',
            display: 'block',
        },
        '&:hover': {
            backgroundColor: palette.cms?.buttonBackgroundColorHover || '#6F6F6F',
        },
    },
    moreDesc: {
        float: 'right',
        marginRight: '22%',
        fontWeight: '700',
    },
    showMoreCopy: {
        height: '400px',
        transition: 'height 0.25s linear',
        margin: '5px',
        backgroundColor: palette.cms?.cardPagebackground || palette.cardPagebackground,
    },
    showLessCopy: {
        height: '273px',
        transition: 'height 0.25s linear',
        margin: '5px',
        backgroundColor: palette.cms?.cardPagebackground || palette.cardPagebackground,
    },
    setAnimationMore: {
        transition: 'height 0.25s linear',
        fontFamily: 'lato regular',
        fontSize: '16px',
        margin: '0 18px',
    },
    headerSingleImage: {
        width: '100%',
        display: 'flex',
        backgroundRepeat: 'no-repeat',
    },
    headerImages: {
        width: '50%',
        backgroundSize: '100%',
        backgroundPosition: ' top left',
        backgroundRepeat: 'no-repeat',
    },
    buttonBlock: {
        width: '85%',
    },
    moreLessButton: {
        float: 'right',
        textTransform: 'lowercase',
        padding: '0',
        fontWeight: '700',
    },
    clubsCategoryTitle: {
        fontSize: '20px',
        fontFamily: 'lato regular',
        margin: '2px',
        display: 'inline-block',
        padding: '0 4px',
        outline: 'none',
        backgroundColor: palette.cms?.cardPagebackground || palette.cardPagebackground,
    },
    decorationNone: {
        textDecoration: 'none',
    },
    imageMaincont: {
        width: '50%',
        float: 'left',
        '& img': {
            [breakpoints.down('md')]: {
                width: '100%',
                height: '100%',
            },
        },
    },
    passportEligibleImage: {
        height: '35px',
    },

    labelStyle: ({ titleFontFamily }) => ({
        fontFamily: titleFontFamily,
    }),
    lcpImage: {
        display: 'none',
    },
});

export default ClubPageStyle;
